import context from 'react-bootstrap/esm/AccordionContext';
import { useLocation } from 'react-router-dom';

import { useAccountContext } from '../../contexts/AccountContext';
import { IUserContext } from '../../contexts/UserContext';
import { Permission, PermissionVerb } from '../../libs/libPermissions';

interface QuickNavItem {
  icon: string;
  name: string;
  path?: string;
  to?: string;
  auth?: (userContext: IUserContext) => boolean; // TODO refactor to remove this as a func and make it just a bool
  exact?: boolean;
  className?: string;
  disabled?: boolean;
}

export const useNavItems = (): QuickNavItem[] => {
  const accountContext = useAccountContext();
  const location = useLocation();

  const navItems: QuickNavItem[] = [
    {
      name: 'Home',
      icon: 'bi-house',
      path: '/',
      exact: true
    },
    {
      name: 'Apps',
      icon: 'bi-grid',
      path: '/apps'
    },
    {
      name: 'Alerts',
      icon: 'bi-exclamation-triangle',
      path: '/alerts',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'alerts'))
    },
    {
      name: 'Cases',
      icon: 'bi-inboxes',
      path: '/cases',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'case'))
    },
    {
      name: 'Files',
      icon: 'bi-folder',
      path: '/files',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'files'))
    },
    {
      name: 'Nodes',
      icon: 'bi-laptop',
      path: '/nodes',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'nodes'))
    },
    {
      name: 'Systems',
      icon: 'bi-collection',
      path: '/systems',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'systems'))
    },
    {
      name: 'GRC',
      icon: 'bi-eye',
      path: '/grc',
      auth: (context) => accountContext.currentAccountEntitlementComponents.find((e) => e.label === 'GRC') != null && location.pathname === '/grc'
    },
    {
      name: 'Status',
      icon: 'bi-check-circle',
      path: '/e/status',
      auth: (context) => location.pathname === '/e/status'
    },
    {
      name: '',
      icon: '',
      className: 'mt-auto'
    },
    {
      name: 'Partner',
      icon: 'bi-people',
      path: '/partner',
      auth: (context) => context.apparentUser.accountIsServiceProvider
    },
    {
      name: 'Admin',
      icon: 'bi-radioactive',
      to: '/admin/',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'admin_site'))
    },
    {
      name: 'Settings',
      icon: 'bi-gear',
      path: '/settings',
      auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'settings')) && context.apparentUser.accountIsServiceProvider
    }
    // {
    //   name: 'Developer',
    //   icon: 'bi-person-badge',
    //   path: '/dev',
    //   auth: (context) => context.hasPermission(new Permission(PermissionVerb.Read, 'developer'))
    // }
  ];

  return navItems;
};
